import $ from 'jquery';
import { standardAjaxPost } from 'stdjs/standard-ajax';
import { displayMessages, destroyMessages } from 'stdjs/validation';
import { confirmModel } from 'stdjs/confirm-model';
import 'bootstrap';

export function deleteModel(url, modelIdName, modelId, successCallback, stayOnPage, domPrefix, message, title, buttonLabel ){

    destroyMessages();
    
    if ( typeof stayOnPage === "undefined" ){
        stayOnPage = true;
    }

    buildModal(function(modal){

        var data = modelIdName + "=" + modelId;

        if (typeof stayOnPage !== "undefined" && stayOnPage){
            data += "&*STAY_ON_PAGE=1"
        } 

        var modifiedSuccessCallback = function(data){            
            successCallback(data);               
            modal.modal("hide");
        }

        var errorCallback = function(data){
            displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
            modal.modal("hide");
        }

        standardAjaxPost(url, data, modifiedSuccessCallback, errorCallback);

    }, title, message, buttonLabel, domPrefix);
}

export function buildModal(successCallback, title, message, buttonLabel, domPrefix){

    if (typeof title === "undefined"){
        title = "Are you sure you wish to delete?";
    }
    
    if (typeof message === "undefined"){
        message = "If you choose to continue this operation cannot be reversed.";
    }
    
    if (typeof buttonLabel === "undefined"){
        buttonLabel = "Delete";
    }
    
    if (typeof domPrefix === "undefined"){
        domPrefix = "";
    }    
        
    var dialogId = "DELETEMODAL";
    var submitButtonId = "deleteModelDelete";
    var cancelButtonId = "deleteModelCancel";

    var oDiv = document.createElement("div");
    oDiv.setAttribute("id", dialogId);
    oDiv.setAttribute("tab-index", -1);
    oDiv.setAttribute("role", "dialog");
    $(oDiv).addClass("modal");
    $(oDiv).addClass("fade");
    oDiv = $(oDiv);
    
    $("body").append(oDiv);
    
    oDiv.html("\
        <div class=\"card modal-dialog\" role=\"document\">\
            <div class=\"modal-content\">\
                <div class=\"modal-header  card-header\">\
                    <div class=\"row no-gutters w-100\">\
                        <div class=\"col-12 text-sm-center text-lg-left\">\
                            <div class=\"d-flex\">\
                                <span class=\"card-header-title flex-grow-1\">" + title + "</span>\
                                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\
                                    <span aria-hidden=\"true\">&times;</span>\
                                </button>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
                <div class=\"modal-body card-body\">\
                    <div class=\"row\">\
                        <div class=\"col\">\
                            <div class=\"\">\
                                " + message + "\
                            </div>\
                        </div>\
                    </div>\
                </div>\
                <div class=\"modal-footer justify-content-around\">\
                    <button id=\"" + cancelButtonId + "\" class=\"btn stdButton\">Cancel</button>\
                    <button id=\"" + submitButtonId + "\" class=\"btn stdButton\">" + buttonLabel + "</button>\
                </div>\
            </div>\
        </div>\
    ");

    oDiv.modal();
    oDiv.on("hidden.bs.modal", function(e){
        oDiv.modal("hide").remove();
    });
    
    var $submitButton = $(domPrefix + "#" + submitButtonId);
    var $cancelButton = $(domPrefix + "#" + cancelButtonId);

    $cancelButton.click(function(event) {
        oDiv.modal("hide");
    });

    $submitButton.click(function(event) {
        successCallback( oDiv );
        oDiv.modal("hide");
    });
}